<template>
    <b-card class="mb-2">
        <h5 class="mb-2">Terapias</h5>
        <!-- Buscador + sesiones -->
        <b-row class="align-items-end">
            <b-col md="7">
                <b-form-group label="Terapia" class="mb-0">
                    <v-select v-model="seleccion" :options="opciones" :reduce="o => o" label="label" :filterable="true"
                        :searchable="true" :clearable="true" placeholder="Buscar terapia por nombre…"
                        @search="onSearch" />
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="N.º de sesiones" class="mb-0">
                    <b-form-input type="number" min="1" step="1" v-model.number="sesiones" />
                </b-form-group>
            </b-col>

            <b-col md="2" class="d-flex align-items-end">
                <b-button variant="primary" block :disabled="!seleccion || !sesiones || sesiones < 1" @click="agregar">
                    + Agregar
                </b-button>
            </b-col>
        </b-row>
        <!-- Listado agregado -->
        <b-table v-if="itemsLocal.length" class="mt-2" small bordered :items="itemsLocal" :fields="fields" responsive>
            <template #cell(acciones)="{ index }">
                <b-button size="sm" variant="danger" @click="eliminar(index)">
                    <i class="fas fa-times" />
                </b-button>
            </template>
        </b-table>

        <b-alert v-else class="mt-2" show variant="danger">
            <i class="fa-solid fa-triangle-exclamation mr-1" />
            No ha registrado ninguna terapia
        </b-alert>
    </b-card>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    name: 'PaqTerapia',
    components: { vSelect },
    props: {
        // lista final controlada por el padre
        items: {
            type: Array,
            default: () => []
        },
        // (opcional) función async de búsqueda: (q) => Promise([{ id, descripcion, label? }])
        buscar: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            opciones: [],
            seleccion: null,
            sesiones: 1,
            itemsLocal: [...this.items],
            fields: [
                { key: 'descripcion', label: 'Terapia' },
                { key: 'sesiones', label: 'Sesiones', tdClass: 'text-center', thClass: 'text-center', class: 'w-15' },
                { key: 'acciones', label: 'Acciones', tdClass: 'text-right', thClass: 'text-right', class: 'w-10' }
            ]
        }
    },
    watch: {
        itemsLocal: {
            handler(v) { this.$emit('update:items', v) },
            deep: true
        }
    },
    methods: {
        async onSearch(q) {
            if (!q || q.trim().length < 3) { this.opciones = []; return }
            if (this.buscar) {
                const rs = await this.buscar(q.trim())
                this.opciones = (rs || []).map(t => ({
                    id: t.id ?? t.value ?? t.codigo,
                    descripcion: t.descripcion ?? t.text ?? t.nombre ?? '',
                    label: t.label ?? `${t.descripcion ?? t.text ?? t.nombre ?? ''}`
                }))
                return
            }
            // modo demo (sin backend)
            this.opciones = Array.from({ length: 6 }).map((_, i) => ({
                id: `T${i + 1}`,
                descripcion: `${q.toUpperCase()} — Terapia ${i + 1}`,
                label: `${q.toUpperCase()} — Terapia ${i + 1}`
            }))
        },
        agregar() {
            if (!this.seleccion || !this.sesiones || this.sesiones < 1) return
            const reg = {
                id: this.seleccion.id,
                descripcion: this.seleccion.descripcion,
                sesiones: this.sesiones
            }
            this.itemsLocal = [...this.itemsLocal, reg]
            this.seleccion = null
            this.sesiones = 1
        },
        eliminar(idx) {
            this.itemsLocal.splice(idx, 1)
        }
    }
}
</script>
<style scoped>
/* Asegura altura homogénea en el control del v-select */
::v-deep .vs__dropdown-toggle { min-height: 38px; }
</style>